import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import type { ShowCreateArticleModalProps } from '../../../common/types.tsx';
import { useIsPermittedSpaces } from '../../store/index.tsx';

export const useNavigateToEditor = ({
	spaces,
	topicId,
	topicName,
	isJcs,
	helpCenterId,
}: ShowCreateArticleModalProps) => {
	const [, { fetchDraftAndNavigateToEditor }] = useIsPermittedSpaces();
	const [{ data: pageContextData }] = usePageContext();
	const [routerState, routerActions] = useRouter();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const navigateToEditor = () => {
		const { projectContext } = pageContextData || {};
		const { projectKey, projectId } = projectContext || {};
		const [{ spaceKey }] = spaces;

		projectKey &&
			projectId &&
			fetchDraftAndNavigateToEditor({
				spaceKey,
				routerActions,
				projectKey,
				projectId,
				onCloseRedirectUrl: routerState.location.pathname,
				analyticsEvent: createAnalyticsEvent({}),
				topicId,
				topicName,
				isJcs,
				helpCenterId,
			});
	};
	return { navigateToEditor };
};
